module.exports = __webpack_public_path__ + "img/cardVideo.efc9ac7e.png";